import { gql } from '@apollo/client'

// Query to get a list of wallet types
export const WALLET_TYPES_QUERY = gql`
  query WalletTypes {
    walletTypes {
      walletType
      isBilateral
    }
  }
`
